import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

/**
 * `max-md:text-base` (16px) NAO e escolha de estilo, e acessibilidade.
 *
 * O iOS Safari da zoom automatico ao focar qualquer campo com fonte abaixo de
 * 16px, e nao reverte de forma confiavel: o usuario fica preso numa tela
 * ampliada. A saida obvia (`maximum-scale=1` no viewport) mata o sintoma
 * violando a WCAG 1.4.4, porque tira o zoom de quem tem baixa visao. O piso de
 * 16px resolve na origem: sem zoom disparado, nao ha zoom para reverter.
 *
 * Por que aqui e nao so no CSS global: os ~50 call sites que passam
 * `text-[13px]` sao a densidade CORRETA do desktop e precisam continuar
 * valendo. Com a classe no primitivo, o `tailwind-merge` resolve conflito de
 * fonte por prefixo de variante, entao o `text-[13px]` do chamador mata o
 * `text-sm` daqui e deixa o `max-md:text-base` intacto. E o Tailwind emite o
 * bloco `max-md:` depois dos utilitarios sem prefixo, entao no celular ele
 * ganha. Desktop fica exatamente como estava.
 *
 * Quem precisar de outro tamanho no celular declara o seu proprio `max-md:`,
 * que o merge entao substitui. Essa e a valvula de escape correta.
 */
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-[var(--color-border)] bg-transparent px-3 py-1 text-sm max-md:text-base text-[var(--color-text)] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[var(--color-text)] placeholder:text-[var(--color-text-muted)] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[var(--color-primary)] disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
